import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import ParticipantForm from "./components/ParticipantForm";
import ValidationQueue from "./components/ValidationQueue";
import DirectionLogin from "./components/DirectionLogin";
import "./App.css";

function DirectionRoute() {
  const [user, setUser] = useState(undefined); // undefined = chargement en cours

  useEffect(() => {
    return onAuthStateChanged(auth, setUser);
  }, []);

  if (user === undefined) return null; // ou un petit indicateur de chargement
  return user ? <ValidationQueue /> : <DirectionLogin />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Lien public unique, partagé à tous les participants */}
        <Route path="/" element={<ParticipantForm />} />
        {/* Accès réservé à la direction (authentification Firebase requise) */}
        <Route path="/direction" element={<DirectionRoute />} />
      </Routes>
    </BrowserRouter>
  );
}
